import React, { useState } from "react";
import { Collapse, Row, Col } from "antd";
import DirectNewBusiness from "./DirectNewBussines";
import PartnerNewBussiness from "./PartnerNewBussiness";
import RenewalsPage from "./Renewals";
import TotalPage from "./Total";
import BreakdownSubscriptions from "./BreakdownSubscriptions";
import EmailStats from "./EmailStats";

const { Panel } = Collapse;

const DashboardPage = () => {
  const [activeKeys, setActiveKeys] = useState<string[]>([]);
  const [loadedKeys, setLoadedKeys] = useState<string[]>([]);

  const handleChange = (keys: string | string[]) => {
    const nextKeys = (Array.isArray(keys) ? keys : [keys]).filter(Boolean);
    setActiveKeys(nextKeys);
    setLoadedKeys((prev) => Array.from(new Set([...prev, ...nextKeys])));
  };

  return (
    <Row>
      <Col span={24} offset={0}>
        <Collapse
          activeKey={activeKeys}
          onChange={handleChange}
          style={{ backgroundColor: "##fff0f0" }}
        >
          <Panel header="Emails (Postmark)" key="emails">
            {loadedKeys.includes("emails") ? <EmailStats /> : null}
          </Panel>
          <Panel header="Direct New Bussiness" key="1">
            {loadedKeys.includes("1") ? <DirectNewBusiness /> : null}
          </Panel>
          <Panel header="Partner New Bussiness" key="2">
            {loadedKeys.includes("2") ? <PartnerNewBussiness /> : null}
          </Panel>
          <Panel header="Renewals" key="3">
            {loadedKeys.includes("3") ? <RenewalsPage /> : null}
          </Panel>
          <Panel header="Total" key="4">
            {loadedKeys.includes("4") ? <TotalPage /> : null}
          </Panel>
          <Panel header="Breakdown Subscriptions" key="5">
            {loadedKeys.includes("5") ? <BreakdownSubscriptions /> : null}
          </Panel>
        </Collapse>
      </Col>
    </Row>
  );
};

export default DashboardPage;
